import template from './calendar.html';

/**
 * Componente que representa a una ventana modal.
 */
export let CalendarComponent = {
  templateUrl: template,
  selector: 'calendar',
  transclude: true,
  bindings: {
    events: '=',
    config: '=?',
    templateId: '@'
  },
  controller: CalendarCtrl,
  controllerAs: 'vm'
};

CalendarCtrl.$inject = ['$element'];

function CalendarCtrl($element) {
  this.$onDestroy = () => {};

  let vm = this;
  this.$postLink = () => {
    vm.config.instance = $element.find('#calendario');
  };

  this.eventSources = [this.events];
  //   [{
  //   // Each time an element is dropped in the calendar this event will fire
  //   events (start, end, _, callback) {
  //     start = moment().startOf('month');
  //     end = moment().endOf('month');
  //     // In my case I have many events I'd like to render, so I make a call to my server to get them
  //     $http.get('/calendar_event').then(function (data) {
  //       let events = [];
  //       angular.forEach(data.data,function(e){
  //         events.push({
  //           title: 'Some Event',
  //           start: moment(e.start_date),
  //           end: moment(e.end_date)
  //         });
  //       });
  //       // This callback calls eventRender in $scope.uiConfig
  //       callback(events);
  //     });
  //   }
  // }];    

}


// WEBPACK FOOTER //
// ./src/core/components/calendar/calendar.component.js